<template>
    <div class="finantial-settings-payout-methods-card">
      <div class="finantial-settings-payout-methods-card__contain">
        <span
          class="finantial-settings-payout-methods-card__contain__icon"
          :class="configCard.iconClass"
        />
        <span
          class="finantial-settings-payout-methods-card__contain__title"
          v-text="title"
        />
        <span
          class="finantial-settings-payout-methods-card__contain__last4"
          v-text="`(****${last4})`"
        />
        <span
          class="finantial-settings-payout-methods-card__contain__description"
          v-text="description"
        />
        <span
          class="finantial-settings-payout-methods-card__contain__country"
          v-text="countryName"
        />
        <div class="finantial-settings-payout-methods-card__contain__actions">
          <el-dropdown
            v-if="!isDefault"
            trigger="click"
          >
            <i class="el-dropdown-link el-icon-more" />
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-button
                    size="small"
                    type="text"
                    @click="destroyMethod"
                    v-text="configCard.deleteButtonText"
                  />
                </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <span
          class="finantial-settings-payout-methods-card__contain__status"
          v-text="_status"
        />
      </div>
      <div 
        class="finantial-settings-payout-methods-card__radio"
        @click="setDefaultMethod"
      >
        <span :class="radioButtonClasses" />
        <span
          class="finantial-settings-payout-methods-card__radio__text" 
          v-text="configCard.defaultText"
        />
      </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

import { i18n } from '@shared/i18n';
import { StripeExternalAccountModel } from '@modules/stripe/stripe-external-account/stripe-external-account-model';

export default {
  name: 'app-finantial-settings-payout-methods-card',

  props: {
    id: {
      type: String,
      required: true
    },
    propertyId: {
      type: String,
      required: true
    },
    subpropertyId: {
      type: String,
      required: true
    },
    connectedAccountId: {
      type: String,
      required: true
    },
    isDefault: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    last4: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    country: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: true
    },
  },

  data() {
    return {
      configCard: {
        iconClass: 'icon-home',
        defaultText: i18n('subpropertySettings.finantial.payoutMethods.default'),
        deleteButtonText: i18n('common.destroy')
      }
    }
  },

  computed: {
    _status() {
      return this.presenter({ status: this.status }, 'status');
    },
    radioButtonClasses() {
      return {
        'finantial-settings-payout-methods-card__radio__icon': true,
        'finantial-settings-payout-methods-card__radio__icon--active': this.isDefault,
        'icon-radio-button-empty': !this.isDefault,
        'icon-radio-button-fill': this.isDefault,
      }
    },
    countryName() {
      return i18n(`enumerators.country.${this.country}`)
    },
  },

  methods: {
    ...mapActions({
      doSetDefault: 'paymentSettings/payoutMethods/doSetDefault',
      doDestroy: 'paymentSettings/payoutMethods/doDestroy',
    }),

    presenter(row, fieldName) {
      return StripeExternalAccountModel.presenter(row, fieldName, {});
    },

    destroyMethod() {
      if (this.isDefault) return
      const { id, propertyId, subpropertyId, connectedAccountId } = this
      this.doDestroy({ id, propertyId, subpropertyId, connectedAccountId })
    },

    setDefaultMethod() {
      if (this.isDefault) return
      const { id, propertyId, subpropertyId, connectedAccountId } = this
      this.doSetDefault({ id, propertyId, subpropertyId, connectedAccountId })
    },
  },
}
</script>

<style lang="scss" scoped>
.finantial-settings-payout-methods-card {
  --actions-width: 15px;

  width: auto;
  display: grid;
  grid-auto-flow: row;
  grid-row-gap: 12px;
  font-size: 14px;

  &__contain {
    padding: 16px 24px;
    border-radius: 4px;
    box-shadow: 0 2px 7px 0 rgba(174, 174, 174, 0.22);
    background-image: radial-gradient(circle at 0 0, #ffffff, #fbfbfb);

    display: grid;
    grid-template-rows: 1fr 1fr auto;
    grid-template-columns: auto 1fr auto var(--actions-width);
    grid-column-gap: 16px;
    grid-row-gap: 8px;
    grid-template-areas: 
      "icon title last4 actions"
      "icon description status status"
      ". country country country";

    &__icon {
      grid-area: icon;
      font-size: 24px;
      align-self: center;
    }

    &__title {
      grid-area: title;
      align-self: center;
      text-transform: capitalize;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__last4 {
      grid-area: last4;
      align-self: center;
      text-transform: capitalize;
    }

    &__description {
      grid-area: description;
      color: #c5c5c5;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__country {
      grid-area: country;
      color: #c5c5c5;
      font-size: 12px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__actions {
      width: var(--actions-width);
      grid-area: actions;
      justify-self: end;
      cursor: pointer;
    }

    &__status {
      grid-area: status;
      color:#2acccc;
      font-size: 12px;
      justify-self: end;
    }
  }

  &__radio {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 27px auto;
    cursor: pointer;

    &__icon {
      color: #999999;
      align-self: center;

      &--active{
        color: #2acccc;
      }
    }

    &__text {
      color: #404040;
    }
  }
}
</style>